export default "__VITE_ASSET__ItqPbP7s__"